import React, { useEffect, useState } from "react";
import InnerHead from "../components/InnerHead";
import Header from "../components/Header";
import ContactUs from "../components/ContactUs";
import Footer from "../components/Footer";
import TrackDetails from "../components/TrackDetails";
import { client } from "../config/prismic";

const Guidelines = () => {
  const [guidelines, setGuidelines] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("guidelines");
      setGuidelines(response.results);
    };
    fetchData();
  }, []);

  if (!guidelines) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  // Function to apply spans (bold/hyperlink) within text
  const renderTextWithSpans = (text, spans) => {
    let lastIndex = 0;
    const elements = [];

    spans.forEach((span) => {
      // Add any text before the span starts as plain text
      if (span.start > lastIndex) {
        elements.push(text.slice(lastIndex, span.start));
      }

      const spanText = text.slice(span.start, span.end);

      // Apply formatting based on span type
      if (span.type === "strong") {
        elements.push(
          <strong key={`${span.start}-${span.end}`}>{spanText}</strong>
        );
      } else if (span.type === "hyperlink") {
        elements.push(
          <a
            key={`${span.start}-${span.end}`}
            href={span.data.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {spanText}
          </a>
        );
      } else {
        elements.push(spanText); // No styling, just plain text
      }

      lastIndex = span.end;
    });

    // Add any remaining text after the last span
    if (lastIndex < text.length) {
      elements.push(text.slice(lastIndex));
    }

    return elements;
  };

  return (
    <div>
      <Header />
      <InnerHead />
      <div
        className="section-title text-center position-relative py-3 my-2 mx-auto"
        style={{ maxWidth: "600px" }}
      >
        <h5 className="fw-bold text-primary text-uppercase">Guidelines</h5>
        <h2 className="mb-0">ICACCTech 2025</h2>
      </div>
      <div className="container my-5">
        {guidelines.map((guideline, index) => (
          <div key={index} className="card shadow-lg mb-4">
            <div className="card-body">
              {guideline.data.guidelines.map((item, itemIndex) => (
                <div key={itemIndex} className="mb-3">
                  {item.type === "paragraph" ? (
                    <p className="card-text text-justify">
                      {renderTextWithSpans(item.text, item.spans)}
                    </p>
                  ) : (
                    <ul>
                      <li className="card-text text-justify">
                        {renderTextWithSpans(item.text, item.spans)}
                      </li>
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <ContactUs />
      <Footer />
    </div>
  );
};

export default Guidelines;
